export const contactEditorTranslation = {
  container: {
    button: {
      edit: 'cng-contact_editor-container-button_edit',
      apply: 'cng-contact_editor-container-button_apply',
      cancel: 'cng-contact_editor-container-button_cancel',
      inactive: 'cng-contact_editor-container-button_inactive',
    },
  },
  menu: {
    basic: 'cng-contact_editor-menu-basic',
    additional: 'cng-contact_editor-menu-additional',
    userRights: 'cng-contact_editor-menu-user_rights',
    campaigns: 'cng-contact_editor-menu-campaigns',
    toolAccess: 'cng-contact_editor-menu-tool_access',
    contactRelinking: 'cng-contact_editor-menu-contact_relinking',
    createReplacementContact: 'cng-contact_editor-menu-create_replacement_contact',
  },
  header: {
    contactFormTitle: {
      formType: 'cng-contact_editor-header-contactformtitle-formtype',
    },
    contactSummury: {
      contactId: 'cng-contact_editor-header-contactsummury-contactid',
      email: 'cng-contact_editor-header-contactsummury-email',
      partnerId: 'cng-contact_editor-header-contactsummury-partnerid',
      locationId: 'cng-contact_editor-header-contactsummury-locationid',
      communicationName: 'cng-contact_editor-header-contactsummury-communication-name',
    },
    default: {
      contactId: 'cng-contact_editor-header-default-contact_id',
    },
  },
  workflowStatus: {
    label: 'cng-contact_editor-workflowstatus-label',
    button: {
      approve: 'cng-contact_editor-workflowstatus-button-approve',
      remove: 'cng-contact_editor-workflowstatus-button-remove',
    },
  },
  other: {
    menuStatus: 'cng-contact_editor-other-menu_status',
  },
  dialog: {
    closeConfirm: {
      title: 'cng-contact_editor-dialog-closeconfirm-title',
      content: 'cng-contact_editor-dialog-closeconfirm-content',
      confirmBtn: 'cng-contact_editor-dialog-closeconfirm-confirm-btn',
      rejectBtn: 'cng-contact_editor-dialog-closeconfirm-reject-btn',
    },
    approveRequest: {
      title: 'cng-contact_editor-dialog-approverequest-title',
      content: 'cng-contact_editor-dialog-approverequest-content',
      confirmBtn: 'cng-contact_editor-dialog-approverequest-confirm-btn',
      rejectBtn: 'cng-contact_editor-dialog-approverequest-reject-btn',
    },
    removeRequest: {
      title: 'cng-contact_editor-dialog-removerequest-title',
      content: 'cng-contact_editor-dialog-removerequest-content',
      confirmBtn: 'cng-contact_editor-dialog-removerequest-confirm-btn',
      rejectBtn: 'cng-contact_editor-dialog-removerequest-reject-btn',
    },
    skipInactivationStep: {
      title: 'cng-contact_editor-dialog-skip_inactivation_step-title',
      content: 'cng-contact_editor-dialog-skip_inactivation_step-content',
      confirmBtn: 'cng-contact_editor-dialog-skip_inactivation_step-confirm-btn',
      rejectBtn: 'cng-contact_editor-dialog-skip_inactivation_step-reject-btn',
    },
    skipBackupStep: {
      title: 'cng-contact_editor-dialog-skip_backup_step-title',
      content: 'cng-contact_editor-dialog-skip_backup_step-content',
      confirmBtn: 'cng-contact_editor-dialog-skip_backup_step-confirm-btn',
      rejectBtn: 'cng-contact_editor-dialog-skip_backup_step-reject-btn',
    },
    inactivateContact: {
      title: 'cng-contact_editor-dialog-inactivate-title',
      content: 'cng-contact_editor-dialog-inactivate-content',
      confirmBtn: 'cng-contact_editor-dialog-inactivate-confirm-btn',
      rejectBtn: 'cng-contact_editor-dialog-inactivate-reject-btn',
    },
    backupContact: {
      title: 'cng-contact_editor-dialog-backup-title',
      content: 'cng-contact_editor-dialog-backup-content',
      confirmBtn: 'cng-contact_editor-dialog-backup-confirm-btn',
    },
  },
  warnings: {
    hasHPRolesDuplicates: 'cng-contact_editor-warnings-has_hp_roles_duplicates',
    inactivateContact: 'cng-contact_editor-warnings-inactivate_contact',
    relinking: 'cng-contact_editor-warnings-relinking', // Add a translation
    awaitingCreation: 'cng-contact_editor-warnings-awaiting_creation',
    successfulUpdate: 'cng-contact_editor-warnings-successful_update',
  },
  relinkingFastCheck: {
    notInHierarchy: 'cng-contact_editor-critical_relinking_countries_not_in_hierarchy',
    countriesNotMatch: 'cng-contact_editor-critical_relinking_countries_not_match',
    domainNotMatch: 'cng-contact_editor-critical_relinking_domain_not_match',
  },
}
